const hasModuleAccess = (user, moduleName) => {
  const perms = user?.module_perms;
  const role = user?.user_role;
  if (role === "GLOBAL" || role === "SUPERADMIN" || role === "TECH") return true;
  // null or empty array = full access
  if (!perms || perms.length === 0) return false;
  
  return perms.includes(moduleName);
};

export const getAccessibleRoutes = (routes, user) => {
  return routes.filter(route => {
    // if its a module-level route, check permission
    if (route.module && route.name) {
      return hasModuleAccess(user, route.name);
    }
    // non-module routes always show
    return true;
  });
};